import { render, staticRenderFns } from "./RetryPixPayment.vue?vue&type=template&id=0520f233&scoped=true&"
import script from "./RetryPixPayment.vue?vue&type=script&lang=js&"
export * from "./RetryPixPayment.vue?vue&type=script&lang=js&"
import style0 from "./RetryPixPayment.vue?vue&type=style&index=0&id=0520f233&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0520f233",
  null
  
)

export default component.exports